import styles from "./css/home2.module.css";



import 블렌더연습2 from './img/블렌더연습20.png';



import { faMessage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';

const Home = () => {
 


  
  return (
    <div className="wrap">
     <style>
        {`
        body{
          max-width:unset;
        
        }
        nav{
          max-width:unset;
          color:white;
        }
        .menus li span {
          padding: 5px 0;
          text-align: center;
          font-size: 1rem;
          height: 100%;
          color: white;
          position: relative;
          font-family: 'NotoSansKR-Light';
      }
      .hoverMenu{
        border:none;
      }

      .menus a:first-of-type .hoverMenu{
        border-left:none;
      }

      section{
        padding-top: 80px;
    --mobile-padding-top: 40px;
    padding-bottom: 80px;
    --mobile-padding-bottom: 40px;
    
      }
      .latest-news{
        padding-top: 80px;
    --mobile-padding-top: 40px;
    padding-bottom: 80px;
    --mobile-padding-bottom: 40px;
        background: center / cover no-repeat #F6F8FC;
      }

      .container {
        margin: 0 auto;
        padding-left: 1rem;
        padding-right: 1rem;
        width: 100%;
    }
    .content-block {
      margin-bottom: 2rem;
  }
  .row.svelte-1xwyt96 {
    display: flex;
    flex-wrap: wrap;
}
.card-wrapper.svelte-1euz3v5.svelte-1euz3v5 {
  height: 399px;
  letter-spacing: .01em;
  width: 33%;
}
.card-wrapper.svelte-1euz3v5 .card.svelte-1euz3v5 {
  height: 399px;
  letter-spacing: .01em;
  width: 100%;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255/var(--tw-bg-opacity));
}
.rounded-lg {
  border-radius: 0.5rem;
}
.card-wrapper.svelte-1euz3v5 .card .cardImage.svelte-1euz3v5 {
  --tw-bg-opacity: 1;
  background-color: rgb(19 31 55/var(--tw-bg-opacity));
  height: 173px;
  position: relative;
}
.card-wrapper.svelte-1euz3v5 .card .cardImage .circle-link.svelte-1euz3v5 {
  bottom: -1.5rem;
  position: absolute;
  right: 2rem;
}
.card-wrapper.svelte-1euz3v5 img{
  height:100%;
}
.circle.svelte-1ewwv7p {
  --tw-bg-opacity: 1;
  align-items: center;
  background: linear-gradient(120deg,#1879bf 50%,#1879bf);
  background-position: 0 0;
  background-size: 200% 100%;
  border-radius: 9999px;
  cursor: pointer;
  display: flex;
  height: 3rem;
  justify-content: center;
  transition: background .3s linear;
  width: 3rem;
}
.card-wrapper.svelte-1euz3v5 .card .cardContent.svelte-1euz3v5 {
  --tw-text-opacity: 1;
  color: rgb(72 87 118/var(--tw-text-opacity));
  display: flex;
  flex-direction: column;
  height: calc(100% - 173px);
  padding: 2rem;
  width: 100%;
}
.text-grey-10pm {
  --tw-text-opacity: 1;
  color: rgb(72 87 118/var(--tw-text-opacity));
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.text-grey-8pm {
  --tw-text-opacity: 1;
  color: rgb(132 147 173/var(--tw-text-opacity));
}
.text-xs {
  font-size: .75rem;
  line-height: 1rem;
}
.justify-between {
  justify-content: space-between;
}
.flex {
  display: flex;
}
.mb-1 {
  margin-bottom: 0.25rem;
}


.body {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  letter-spacing: .04em;
}

.row1{
  padding-top: 212px;
  padding-bottom: 212px;
  position:relative;
  background-color:#f4f8f9;
  overflow:hidden;
}
.row1:before {
  background-image: url(./img/패턴.svg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  content: "";
  height: 1041px;
  opacity: .2;
  position: absolute;
  width: 1158px;
  right:60%;
  top: 50%;
  transform: translateY(-50%);
  
}
.mb-8 {
  margin-bottom: 2rem;
}
.richtext-block{
color: rgb(19, 31, 55);

}

h2 {
  font-size: 2.5rem;
  line-height: 2.5rem;
}
.headline-stick.size-l {
  width: 80px;
}
.headline-stick {
  --tw-bg-opacity: 1;
  background-color: rgb(0 224 202/var(--tw-bg-opacity));
  height: 4px;
  margin-bottom: 1.25rem;
  width: 16px;
}

.blendImg{
  width:100%;
  height:100%;
  z-index:100;
  display:flex;
  align-items:center;
  
}

.hero-with-partnership-mark.vertical-centered .text-wrapper {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  top: 2vh;
}
.hero-with-partnership-mark.withhighlightbar .text-wrapper {
  height: calc(100vh - 9rem);
}
.hero-with-partnership-mark .text-wrapper {
  padding: 72px 0;
}
.hero-with-partnership-mark .text-render {
  padding: 0;
  width: 50%;
  z-index: 2;
}
.hero-with-partnership-mark .text-s .headline {
  font-size: 2.75rem;
  line-height: 3.25rem;
  color:white;
}
.text-wrapper{
  width:50%;
  margin-left:10%;
}
.headline, .description{
  color:white;
  font-family:'Merchant-Light';
  margin-top:2rem;
}

.btn.green.svelte-lt6zv4.svelte-lt6zv4 {
  --tw-bg-opacity: 1;
  --tw-text-opacity: 1;
  background-color: rgb(15 193 183/var(--tw-bg-opacity));
  background: linear-gradient(120deg,#0fc1b7 50%,#00e0ca);
  background-position: 0 0;
  background-size: 200% 100%;
  color: rgb(255 255 255/var(--tw-text-opacity));
  border-radius: 0.5rem;
    color: rgb(255 255 255/var(--tw-text-opacity));
    flex-shrink: 0;
    font-size: 1rem;
    font-weight: 700;
    letter-spacing: .08em;
    line-height: 1.5rem;
    line-height: 1.25;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    transition: all .3s ease-in-out;
    transition-property: background,border-color;
}
.btn.green.svelte-lt6zv4.svelte-lt6zv4:before {
  background: rgba(0,224,202,.2);
}
.btn.svelte-lt6zv4.svelte-lt6zv4:before {
  border-radius: 0.5rem;
  content: "";
  height: 0;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 0;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-4 {
  padding-bottom: 1rem;
  padding-top: 1rem;
}
.grow {
  flex-grow: 1;
}

.main_products{
  width:80%;
  margin:0 auto;
  max-width: 1320px;
  padding:200px 0;
}

.main_products img{
  height:500px;
}
.swiper{
  display:block;
  overflow:hidden;
}

.row2{
  width:100%;
  background:white;
  display:flex;
  height:500px;
  padding:0;margin:0;
  flex-direction:row;
}

.row2 .img_wrap{
  height:100%;
  width:50%;
  background-color:#eee;
  
}
.row2 .img_wrap img{
  object-fit:cover;
  width:100%;
  height:100%;
}

.purple-to-blue-gradient-bg {
  background: #373737;
  display: flex;
  justify-content: center;
}
.footer{
  margin-top:0px;
}

.desc {
  display:flex;
  flex-direction:column;
  justify-content:center;
  height:100%;
  position:relative;
  color:black;
  width:50%;

}
.desc_wrap{
  padding-left:100px;
  width:70%;
}

.md-homepage-module.-product .md-homepage-module__product-logo img {
  height: 60px;
  width: auto;
}
.md-homepage-module__product-logo {
  max-width: 100%;
  width:184px;
}
.md-homepage-module.-product .md-homepage-module__product-logo {
  margin-bottom: 2rem;
}

.md-homepage-module__header.-alignleft h2 {
  text-align: left;
}
.md-homepage-module__header h2 {
  font-weight: 900;
  font-size: 2.35rem;
  text-align: center;
}
.accent__yellow .underscore::after {
  background-color: #f68d35;
}
.underscore::after {
  content: '';
  display: block;
  background-color: #716a9e;
  margin-top: 1.5rem;
  height: 6px;
  width: 50px;
}
.md-homepage-module__btns {
  display: flex;
  flex-flow: wrap;
}


.lang-menu .selected-lang {
  
  color: white;
 
}
.lang-menu .selected-lang svg{
  fill:#fff;

}
nav:hover .lang-menu .selected-lang {
  
  color: black;
 
}

.fixed .lang-menu .selected-lang{
  color:black;
}
.cta-container{
  margin-top:3rem;
}
.cta-container a {
  background:#3c5699;
  padding:15px 30px;
  
  font-size:1.2rem;
  border-radius:10px;
  color:white;
}

.contact-inner-container {
  display: flex;
  flex-direction: column;
}

@import url('https://fonts.googleapis.com/css2?family=Eczar&display=swap');

.row2 p {
  width: 100%;
  margin: 0 auto;
  margin-top:20px;
  color:#38354a;font-family: 'Roboto', sans-serif;

}
.md-homepage-module__header h2 {
  font-weight: 900;
  font-size: 2.35rem;
  text-align: center;
  font-family: 'Eczar', serif;
  color:#38354a;
}
.lang-menu ul li a {
  
  color: black !important;

}
.desc ul{
  padding-left: 28px;
  position:relative;margin-top: 15px;
}
.desc li{
  list-style:none;
  color:#38354a;font-family: 'Roboto', sans-serif;
}

.desc li::before{
  background: transparent url(data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='black' viewBox='0 0 9 8'%3E%3Cpath stroke='%23556170' d='m.5 4 3 2.5L8 1'/%3E%3C/svg%3E) no-repeat !important;
    content: "";
    height: 7px;
            
    left: 0;
    position: absolute;
    top: 8px;
    width: 8px;
}











.sh4 {
  font-size: 18px;
}
.sh3, .sh4 {
  font-family: Source Code Pro,monospace;
  font-weight: 500;
  line-height: 120%;
}

.text-blue1 {
  --tw-text-opacity: 1;
  color: rgb(23 33 43/var(--tw-text-opacity));
}
.uppercase {
  text-transform: uppercase;
}
.mb-[8px] {
  margin-bottom: 8px;
}

.h2 {
  font-size: 60px;
}
.h2 {
  font-family: Open Sans,sans-serif;
  font-size: 36px;
  font-weight: 300;
  line-height: 120%;
}
.text-blue1 {
  --tw-text-opacity: 1;
  color: rgb(23 33 43/var(--tw-text-opacity));
}
.body-md-regular, .body-md-semibold {
  font-family: Open Sans,sans-serif;
  font-size: 18px;
  letter-spacing: .03em;
  line-height: 160%;
}
.body-md-regular {
  font-weight: 400;
}
.text-blue162 {
  color: rgba(23,33,43,.62);
}
.flex {
  display: flex;
}
.mt-40px {
  margin-top: 40px;
}

.btn-md-primary, .btn-sm-primary {
  --tw-bg-opacity: 1;
  --tw-text-opacity: 1;
  --tw-shadow: inset 0px 0px 0px 1px hsla(0,0%,100%,.2);
  --tw-shadow-colored: inset 0px 0px 0px 1px var(--tw-shadow-color);
  background-color: rgb(50 118 181/var(--tw-bg-opacity));
  border-radius: 4px;
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  color: rgb(255 255 255/var(--tw-text-opacity));
  font-weight: 600;
  letter-spacing: .03em;
  text-transform: uppercase;
  transition-duration: 80ms;
  transition-timing-function: ease-out;
  font-size:16px;
  line-height:20px;
}

.lg:mt-120px {
  margin-top: 120px;
}



.lg:p-40px {
  padding: 40px;
}
.lg:p-40px {
  padding: 40px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.bg-gray420 {
  background-color: rgba(221,225,228,.2);
}


.lg:w-600px {
  width: 600px;
}

.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}

.flex-col {
  flex-direction: column;
}
.max-w-full {
  max-width: 100%;
}
.h-full {
  height: 100%;
}

.w-auto {
  width: auto;
}
.h-60px {
  height: 60px;
}
img, video {
  height: auto;
  max-width: 100%;
}
.text-center {
  text-align: center;
}

.mt-20px {
  margin-top: 20px;
}
.h3 {
  font-size: 40px;
}

.h3 {
  font-family: Open Sans,sans-serif;
  font-weight: 300;
  line-height: 120%;
}
.text-blue1 {
  --tw-text-opacity: 1;
  color: rgb(23 33 43/var(--tw-text-opacity));
}
.lg:mb-0 {
  margin-bottom: 0;
}
.body-md-regular, .body-md-semibold {
  font-family: Open Sans,sans-serif;
  font-size: 18px;
  letter-spacing: .03em;
  line-height: 160%;
}
.body-md-regular {
  font-weight: 400;
}



.link-md-light, .link-sm-light {
  --tw-text-opacity: 1;
  align-items: center;
  color: rgb(68 112 153/var(--tw-text-opacity));
  display: flex;
  font-family: Source Code Pro,monospace;
  font-weight: 600;
  letter-spacing: .03em;
  line-height: 160%;
  padding-left: 4px;
  padding-right: 4px;
  position: relative;
  text-transform: uppercase;
  transition-duration: .15s;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}
.link-md-light:before, .link-sm-light:before {
  --tw-bg-opacity: 1;
  --tw-content: "";
  background-color: rgb(68 112 153/var(--tw-bg-opacity));
  bottom: 0;
  content: var(--tw-content);
  height: 1px;
  left: 0;
  position: absolute;
  width: 100%;
}


.py-40px{
  padding: 40px;
}

`}
      </style>

      
  
  <div className={styles.main_visual} >
    <div className="blendImg" style={{ backgroundImage: `url(${블렌더연습2})`, width:"100%", height:"100%",backgroundSize:"cover" }}>



    <div class="text-wrapper">
            <div class="text-render text-s">
                <div class="eyebrow">
                </div>
                       
                    <h2 class="headline is-hidden-mobile">
                    Why bad strategy is a ‘social contagion’  </h2>

                    <p class="description">
                        Amid turbulence on the path to net zero, leaders will have to be much nimbler to balance resilience with an energy future that is secure, affordable, and clean.
                    </p>
                                        <div class="cta-container">
                                <a class="cta -arrow" href="/capabilities/sustainability/our-insights/a-devilish-duality-how-ceos-can-square-resilience-with-net-zero-promises" target="" aria-label="">5 core actions</a>
                        </div>

            </div>
        </div>
      
    </div>

    
  </div>
      

  <div className="row1">
  <div class="content-block fade-in-bottom w-full lg:col-6 text-center svelte-1be2l8v fade-in-bottom-animate">  
  <div class="mb-8"><div class="eyebrow text-green-regular  svelte-16unb9k">Introducing</div></div> 
  <div class="title richtext-block relative"><div class="rich-text-block">
    <h2 id="an-open-feeless-data-and-value-transfer-protocol">An Open, Feeless Data and Value Transfer Protocol</h2><p></p></div> 
    </div> <div class="headline-stick size-l mx-auto"></div> <div class="richtext-block">
      <div class="rich-text-block"><p>
      GMMEDICAL has fundamentally reengineered distributed ledger technology, enabling secure exchange of both value <i>and</i> data, without any fees.</p></div></div>  
        <div class="cta "><a target="_self" class="btn inline-block cursor-pointer green normal svelte-lt6zv4" href="/get-started/what-is-iota"> <div class="py-4 px-6 grow">
          learn about GMMEDICAL</div></a></div>
      </div>
  </div>

  <section id="hover-cards">
    <div class="container space-between-sections">
        <div class="grid grid-cols-12">
            <div class="col-span-12 md:col-span-8 lg:col-span-6">
                <div class="header ">
            <p class="sh4 uppercase mb-8px text-blue1">
            our products
        </p>
        <div>
                                    <h2 class="h2 text-blue1">
                    For data scientists by data scientists
                </h2>
                        </div>

    
            <div class="description mt-24px text-blue162 body-md-regular link-p:link-light">
            <p>We develop R and Python-based tools to help you produce higher quality analysis faster.</p>

        </div>
    
            <div class="mt-40px flex ">
                            <a href="https://posit.co/products/" role="button" target="" class="btn btn-md-primary" aria-label="View our products">
                    View our products
            </a>
                    </div>
    
    
    
    </div>
            </div>
        </div>
        <div class="grid grid-cols-12 mt-80px lg:mt-120px" style={{marginTop:"120px"}}>
            <div id="hover-cards-container" class="grid grid-cols-12 col-span-12 lg:col-span-10 lg:col-start-3 md:gap-x-16px lg:gap-x-28px md:gap-y-24px">
              <div class="bg-gray420 hover:bg-blue3/10 h-auto lg:h-437px py-40px md:py-60px px-20px lg:p-40px
                                      rounded-lg col-span-12 full-width" 
                                    style={{height: "437px", padding:"40px"}}>
                        <div class="flex flex-col justify-center items-center h-full mx-auto max-w-full w-full lg:w-600px" style={{width:"600px"}}>
                            <img class="w-auto h-[60px] lazyloaded" src="https://posit.co/wp-content/uploads/2022/09/enterprise.svg" 
                            alt="icon of 3 different sized devices" data-src="https://posit.co/wp-content/uploads/2022/09/enterprise.svg" decoding="async"/><noscript>
                              <img class="w-auto h-60px" src="https://posit.co/wp-content/uploads/2022/09/enterprise.svg" alt="icon of 3 different sized devices" data-eio="l" /></noscript>
                            <div class="mt-20px text-center">
                                <h3 class="h3 text-blue1">
                                    Enterprise for professionals
                                </h3>
                            </div>
                            <div class="body-md-regular text-blue162 text-center mt-8px mb-20px lg:mb-0">
                                <p>Securely share data-science applications<br/>
 across your team—and the enterprise.</p>

                            </div>
                            <div class="mt-auto lg:mt-20px">
                                <a class=" link link-md-light" href="https://posit.co/products/enterprise/" target="">
        Learn more
                        <svg class="ml-7px" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 12.9999L13.5 8.49992L9.5 3.99992" stroke="#447099" stroke-linejoin="bevel"></path>
        <path d="M13 8.5H3" stroke="#447099" stroke-linejoin="bevel"></path>
    </svg>
            </a>                            </div>
                        </div>
                    </div>
                    <div style={{display:"flex", width:"100%", marginTop:"24px"}}>
                                    <div class="bg-gray420 hover:bg-blue3/10 h-auto lg:h-437px py-40px md:py-60px px-20px lg:p-40px rounded-lg col-span-12 md:col-span-6 half-width" 
                                    style={{height: "437px", width: "49%"}}>
                        <div class="flex flex-col justify-center items-center h-full mx-auto max-w-full w-275px">
                            <img class="w-auto h-60px ls-is-cached lazyloaded" src="https://posit.co/wp-content/uploads/2022/09/door-open.svg" 
                            alt="icon of open door" data-src="https://posit.co/wp-content/uploads/2022/09/door-open.svg" decoding="async"/><noscript>
                              <img class="w-auto h-60px" src="https://posit.co/wp-content/uploads/2022/09/door-open.svg" alt="icon of open door" data-eio="l" /></noscript>
                            <div class="mt-20px text-center">
                                <h3 class="h3 text-blue1">
                                    Open Source
                                </h3>
                            </div>
                            <div class="body-md-regular text-blue162 text-center mt-8px mb-20px lg:mb-0">
                                <p>Our code is your code. Build on it. Share it. Improve people’s lives with it.</p>

                            </div>
                            <div class="mt-auto lg:mt-20px">
                                <a class=" link link-md-light" href="https://posit.co/products/open-source/" target="">
        Learn more
                        <svg class="ml-7px" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 12.9999L13.5 8.49992L9.5 3.99992" stroke="#447099" stroke-linejoin="bevel"></path>
        <path d="M13 8.5H3" stroke="#447099" stroke-linejoin="bevel"></path>
    </svg>
            </a>                            </div>
                        </div>
                    </div>
                                    <div class="bg-gray420 hover:bg-blue3/10 h-auto lg:h-437px py-40px md:py-60px px-20px lg:p-40px [&amp;:not(:first-of-type)]:mt-[24px] md:[&amp;:not(:first-of-type)]:mt-0 rounded-lg col-span-12 md:col-span-6 half-width" 
                                    style={{height: "437px", width: "49%", transform: "translate(0px, 0px);", marginLeft:"2%"}}>
                        <div class="flex flex-col justify-center items-center h-full mx-auto max-w-full w-275px">
                            <img class="w-auto h-60px ls-is-cached lazyloaded" src="https://posit.co/wp-content/uploads/2022/09/cloud.svg" 
                            alt="icon of window and two clouds" data-src="https://posit.co/wp-content/uploads/2022/09/cloud.svg" decoding="async"/><noscript>
                              <img class="w-auto h-60px" src="https://posit.co/wp-content/uploads/2022/09/cloud.svg" alt="icon of window and two clouds" data-eio="l" /></noscript>
                            <div class="mt-20px text-center">
                                <h3 class="h3 text-blue1">
                                    Cloud Solutions
                                </h3>
                            </div>
                            <div class="body-md-regular text-blue162 text-center mt-8px mb-20px lg:mb-0">
                                <p>Take the time and effort out of uploading, storing, accessing, and sharing your work.</p>

                            </div>
                            <div class="mt-auto lg:mt-20px">
                                <a class=" link link-md-light" href="https://posit.co/products/cloud/" target="">
        Learn more
                        <svg class="ml-7px" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 12.9999L13.5 8.49992L9.5 3.99992" stroke="#447099" stroke-linejoin="bevel"></path>
        <path d="M13 8.5H3" stroke="#447099" stroke-linejoin="bevel"></path>
    </svg>
            </a>                            </div>
                        </div>
                    </div>
                    </div>
                            </div>
        </div>
    </div>
</section>

<section class="z-10 overflow-hidden py-10 md:py-20 relative   svelte-am2ffe latest-news"> 
<div class="container "> 
<div class="mx-auto   svelte-am2ffe">
  <div class="content-block fade-in-bottom text-left svelte-1be2l8v fade-in-bottom-animate">   
  <div class="title richtext-block relative">
    <div class="rich-text-block">
      <h2 id="latest-news-and-blog-posts">Latest news and blog posts
      </h2><p></p>
    </div> 
  </div>    
</div> 
<div class="row justify-baseline svelte-1xwyt96">
  <div class="fade-in-bottom row flex flex-wrap w-full fade-in-bottom-animate">
    <a class="card-wrapper news-card mb-8 svelte-1euz3v5" href="https://blog.iota.org/login-with-iota-walt-id/" target="_blank" rel="noopener noreferrer" key="newsCard-0">
      <div class="card overflow-hidden rounded-lg bg-white svelte-1euz3v5">
        <div class="cardImage svelte-1euz3v5">
          <img class="object-cover w-full h-full lazyloaded" data-src="https://blog.iota.org/content/images/size/w600/2022/07/Item375_IOTA_blogheader-2.png" 
          alt="Login With IOTA is Coming!" src="https://blog.iota.org/content/images/size/w600/2022/07/Item375_IOTA_blogheader-2.png"/> 
          <div class="circle-link svelte-1euz3v5">
            <a href="https://blog.iota.org/login-with-iota-walt-id/" target="_blank" aria-label="https://blog.iota.org/login-with-iota-walt-id/" rel="noopener noreferrer">
              <div class="circle svelte-1ewwv7p">
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 11L6 6L1 1" stroke="#F6F8FC" stroke-width="2"></path>
                </svg>
              </div>
            </a>
          </div>
        </div> 
        <div class="cardContent svelte-1euz3v5">
          <h5 class="clampHeading mb-1 text-grey-10pm" >
            Login With IOTA is Coming!
          </h5> 
          <div class="text-grey-8pm text-xs flex justify-between mb-1">
            <div>JUL 27 2022</div>
          </div> 
          <div class="body clampBody">
            The IOTA Foundation and walt.id to Bring Seamless Sign-In to the World
        TL;DR: 
        The IOTA Foundation and walt.id are developing a privacy-preserving, SSI-based
        login system allowing traditional (Web2) and decentralized (Web3) apps to easily
        onboard users. Users remain in full control of their data and will be able to
        securely share information at their discretion.



        The IOTA Foundation is developing a privacy-preserving login system based on
        self-sovereign identity (SSI) called Login With IOTA, </div></div></div> 
    </a>

    <a class="card-wrapper news-card mb-8 svelte-1euz3v5" href="https://blog.iota.org/login-with-iota-walt-id/" target="_blank" rel="noopener noreferrer" key="newsCard-0">
      <div class="card overflow-hidden rounded-lg bg-white svelte-1euz3v5">
        <div class="cardImage svelte-1euz3v5">
          <img class="object-cover w-full h-full lazyloaded" data-src="https://blog.iota.org/content/images/size/w600/2022/07/Item375_IOTA_blogheader-2.png" 
          alt="Login With IOTA is Coming!" src="https://blog.iota.org/content/images/size/w600/2022/07/Item375_IOTA_blogheader-2.png"/> 
          <div class="circle-link svelte-1euz3v5">
            <a href="https://blog.iota.org/login-with-iota-walt-id/" target="_blank" aria-label="https://blog.iota.org/login-with-iota-walt-id/" rel="noopener noreferrer">
              <div class="circle svelte-1ewwv7p">
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 11L6 6L1 1" stroke="#F6F8FC" stroke-width="2"></path>
                </svg>
              </div>
            </a>
          </div>
        </div> 
        <div class="cardContent svelte-1euz3v5">
          <h5 class="clampHeading mb-1 text-grey-10pm" >
            Login With IOTA is Coming!
          </h5> 
          <div class="text-grey-8pm text-xs flex justify-between mb-1">
            <div>JUL 27 2022</div>
          </div> 
          <div class="body clampBody">
            The IOTA Foundation and walt.id to Bring Seamless Sign-In to the World
        TL;DR: 
        The IOTA Foundation and walt.id are developing a privacy-preserving, SSI-based
        login system allowing traditional (Web2) and decentralized (Web3) apps to easily
        onboard users. Users remain in full control of their data and will be able to
        securely share information at their discretion.



        The IOTA Foundation is developing a privacy-preserving login system based on
        self-sovereign identity (SSI) called Login With IOTA, </div></div></div> 
    </a>

    <a class="card-wrapper news-card mb-8 svelte-1euz3v5" href="https://blog.iota.org/login-with-iota-walt-id/" target="_blank" rel="noopener noreferrer" key="newsCard-0">
      <div class="card overflow-hidden rounded-lg bg-white svelte-1euz3v5">
        <div class="cardImage svelte-1euz3v5">
          <img class="object-cover w-full h-full lazyloaded" data-src="https://blog.iota.org/content/images/size/w600/2022/07/Item375_IOTA_blogheader-2.png" 
          alt="Login With IOTA is Coming!" src="https://blog.iota.org/content/images/size/w600/2022/07/Item375_IOTA_blogheader-2.png"/> 
          <div class="circle-link svelte-1euz3v5">
            <a href="https://blog.iota.org/login-with-iota-walt-id/" target="_blank" aria-label="https://blog.iota.org/login-with-iota-walt-id/" rel="noopener noreferrer">
              <div class="circle svelte-1ewwv7p">
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 11L6 6L1 1" stroke="#F6F8FC" stroke-width="2"></path>
                </svg>
              </div>
            </a>
          </div>
        </div> 
        <div class="cardContent svelte-1euz3v5">
          <h5 class="clampHeading mb-1 text-grey-10pm" >
            Login With IOTA is Coming!
          </h5> 
          <div class="text-grey-8pm text-xs flex justify-between mb-1">
            <div>JUL 27 2022</div>
          </div> 
          <div class="body clampBody">
            The IOTA Foundation and walt.id to Bring Seamless Sign-In to the World
        TL;DR: 
        The IOTA Foundation and walt.id are developing a privacy-preserving, SSI-based
        login system allowing traditional (Web2) and decentralized (Web3) apps to easily
        onboard users. Users remain in full control of their data and will be able to
        securely share information at their discretion.



        The IOTA Foundation is developing a privacy-preserving login system based on
        self-sovereign identity (SSI) called Login With IOTA, </div></div></div> 
    </a>

</div></div></div></div> 

<div class="cta " style={{display:"flex", justifyContent:"center"}}><a target="_self" class="btn inline-block cursor-pointer green normal svelte-lt6zv4" href="/get-started/what-is-iota"> <div class="py-4 px-6 grow">
          SEE ALL POSTS</div></a></div>

</section>
    


<div class="purple-to-blue-gradient-bg"><div class="contact-container">
<div style={{height:"90px"}} aria-hidden="true"></div>



<div class="contact-inner-container">
<div style={{flexBasis:"70%"}}>
<h4 style={{fontSize:"1.875rem"}}>궁금한 내용이 있으신가요?</h4>



<p class="text-header" style={{fontSize:"18px"}}>문의해 주시면 자세하게 답변해드리겠습니다.</p>
</div>



<div style={{flexBasis:"30%"}}>
<div>
<a href="/inquiry">
<div class="contact-block-button" id="chatwithsales" style={{fontSize:"1.125rem"}}><i class="fa fa-comments-o" aria-hidden="true"></i> 
<FontAwesomeIcon icon={faMessage} />문의하기</div>
</a>
</div>
</div>
</div>



<div style={{height:"90px"}} aria-hidden="true" class="wp-block-spacer"></div>
</div></div>

    </div>

    

      
  );
};
  
export default Home;